import React from "react";
import { Modal, ModalHeader } from "react-bootstrap";
import QRCode from "react-qr-code";
import { MyModal } from "../features/RadConnStyle";

export default function QrCodeGenerator(props) {
  const [showOption, setShowOption] = props.qrOption;

  const handleClose = () => {
    // setShowOption({ show: false });
    if (showOption.action) {
      showOption?.action({ value: "ok" });
    } else {
      setShowOption({ show: false });
    }
  };

  return (
    <MyModal show={showOption?.show} onHide={handleClose} centered>
      <Modal.Header style={{ backgroundColor: "#0f9926" }} closeButton>
        <div style={{ color: "#f0f7ef" }}>ยืนยันการรับข้อมูลด้วยระบบ LINE</div>
      </Modal.Header>
      <Modal.Body style={{ padding: "0px" }}>
        <div
          style={{
            backgroundColor: "#ffffff",
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: "20px",
          }}
        >
          <QRCode value={showOption?.value || "123"} />
          <input
            style={{ margin: "10px", textAlign: "center", borderRadius: "5px" }}
            type="text"
            onChange={(e) => {}}
            value={showOption?.value}
          />
        </div>
      </Modal.Body>
    </MyModal>
  );
}
